import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
